<template>
  <div id="app">
    <router-view></router-view>
  </div>
</template>

<script>
export default {
  name: 'App',
  data() {
    return {
      msg: ''
    }
  },
  beforeCreate() {
    const url = window.location.href
    let status
    const mainUrl = url.split('?')
    if (mainUrl.length > 1) {
      const failUrl =
        mainUrl && mainUrl[1].indexOf('returnMsg=') > -1
          ? mainUrl[1].split('returnMsg=')[1]
          : ''
      status =
        mainUrl[1].indexOf('returnCode=1') > -1
          ? `完成交易，
         前往遊戲查收代鈔！`
          : decodeURIComponent(failUrl)
      this.$store.commit('setMsg', status)
    }
    if (this.$route.path === '/home/pay') {
      this.$store.commit('setPay', true)
    }
  }
}
</script>

<style></style>
